export const ADD = "ADD";
export const CREATE_CLIENT_ADMIN = "CREATE_CLIENT_ADMIN";
export const EDIT = "EDIT";
export const PERSONAL_INFORMATION = "PERSONAL_INFORMATION";
export const PROFILE = "PROFILE";
